<div class="left-modal">
  <div class="close" (click)="close()"></div>
  @if (loading) {
    <div class="loader"></div>
  }
  @if (!loading) {
    <div class="modal-container">
      <div class="L-12 M-12 S-12 columns">
        <h1>{{'Export' | translate}}</h1>
        <form #form="ngForm" (ngSubmit)="submitForm()" novalidate>
          <div class="L-12 M-12 S-12 columns">
            <label>{{'Report' | translate}}**</label>
            <select name="report_type" [(ngModel)]="report_type" required>
              <option disabled value="">{{'Select option' | translate}}</option>
              <option value="services">{{'Services' | translate}}</option>
            </select>
          </div>
          @if (report_type == 'services') {
            @if (!currentProject) {
              <div class="L-12 M-12 S-12 columns">
                <label>{{'Projects' | translate}}</label>
                <app-dropdown
                  [(appModel)]="filterArgumentsCopy.projects"
                  [list]="lists.projects"
                  [value]="'id'"
                  [name]="'title'"
                  [multiple]="true"
                ></app-dropdown>
              </div>
            }
            <div class="L-6 M-6 S-6 columns">
              <label>{{'Date from' | translate}}</label>
              <input class="centered" [attr.max]="filterArgumentsCopy.date_to" type="date" name="date_from" [(ngModel)]="filterArgumentsCopy.date_from" placeholder="{{'Insert date' | translate}}">
            </div>
            <div class="L-6 M-6 S-6 columns">
              <label>{{'Date to' | translate}}</label>
              <input class="centered" [attr.min]="filterArgumentsCopy.date_from" type="date" name="date_to" [(ngModel)]="filterArgumentsCopy.date_to" placeholder="{{'Insert date' | translate}}">
            </div>
            <div class="L-4 M-4 S-4 columns">
              <label>{{'Unit' | translate}}</label>
              <app-dropdown
                [(appModel)]="filterArgumentsCopy.units"
                [list]="lists.units"
                [value]="'id'"
                [name]="'unit_name'"
                [multiple]="true"
              ></app-dropdown>
            </div>
            <div class="L-4 M-4 S-4 columns">
              <label>{{'Status' | translate}}</label>
              <app-dropdown
                [(appModel)]="filterArgumentsCopy.status"
                [list]="lists.service_statuses"
                [value]="'id'"
                [backTranslate]="true"
                [name]="'se_st_name'"
                [multiple]="true"
              ></app-dropdown>
            </div>
            <div class="L-4 M-4 S-4 columns">
              <label>{{'Category' | translate}}</label>
              <app-dropdown
                [(appModel)]="filterArgumentsCopy.category"
                [list]="lists.service_categories"
                [value]="'id'"
                [backTranslate]="true"
                [name]="'category_name'"
                [multiple]="true"
              ></app-dropdown>
            </div>
          }
          <div class="L-12 M-12 S-12 columns TextCentered">
            <input name="sumbit" [disabled]="form.invalid"  type="submit" value="{{'View report' | translate}}">
          </div>
          <div class="L-12 M-12 S-12 columns TextCentered">
            <a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
          </div>
        </form>
      </div>
    </div>
  }
</div>